<template>
  <div>
    <van-cell-group>
      <van-field
        v-model="listQuery.username"
        clearable
        label="收缩压"
        placeholder="请输入收缩压"
      />

      <van-field
        v-model="listQuery.password"
        type="password"
        label="舒张压"
        placeholder="请输入舒张压"
      />
      <van-field
        v-model="listQuery.password"
        type="password"
        label="舒张压"
        placeholder="请输入舒张压"
      />
      <van-field
        v-model="listQuery.password"
        type="password"
        label="心率"
        placeholder="请输入测量心率"
      />
      <van-field
        v-model="listQuery.password"
        type="password"
        label="录入时间"
        disabled
        placeholder="请选择测量时间"
        right-icon="arrow"
        @click="show=true"
      />
    </van-cell-group>
    <van-button type="primary" size="large" class="surebtn">
      确定
    </van-button>
    <van-popup v-model="show" position="right" :overlay="false">
      <div class="timebox">
        <van-cell-group>
          <van-cell class="sy-cell" title="时段">
            <template>
              <span v-for="(item,index) in timeArr" :key="index" :class="choseIndex==index?'timebtn timebtncolor':'timebtn'" @click="chose(index)">{{ item }}</span>
            </template>
          </van-cell>
          <van-field
            v-model="form.high"
            type="password"
            label="浓度"
            placeholder="请输入舒张压"
          />
          <van-cell class="sy-cell" title="录入时间">
            <template>
              <span @click="showPicker('date')">{{ form.time || $t('viewBase.a72') }}</span>
              <van-popup v-model="showtime" class="date-pick" position="bottom" :overlay="false">
                <van-datetime-picker
                  v-model="currentDate"
                  type="date"
                  @confirm="confirm"
                  @cancle="cancel"
                />
              </van-popup>
            </template>
          </van-cell>
        </van-cell-group>
        <div class="sy-cell">
          <van-button type="default" size="large" class="surebtn" @click="show=false">
            取消
          </van-button>
          <van-button type="primary" size="large" class="surebtn" @click="show=false">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { dateFormat } from '../../utils/tool.js'
export default {
  name: 'Xy',
  data() {
    return {
      timeArr: ['餐前', '餐后', '空腹'],
      listQuery: {
        password: '',
        username: ''
      },
      form: {
        time: '',
        high: '',
        chose: ''
      },
      show: false,
      currentDate: new Date(),
      showtime: false,
      choseIndex: 0
    }
  },
  methods: {
    confirm(value) {
      this.showtime = false
      this.form.time = dateFormat(new Date(value), 'YYYY/MM/DD')
    },
    cancel(value) {
      this.showtime = false
    },
    showPicker(value) {
      switch (value) {
        case 'date':
          this.showtime = true
          break
      }
    },
    chose(index) {
      this.choseIndex = index
      this.form.chose = this.timeArr[index]
    }
  }
}
</script>
<style lang="scss" scoped>
.van-button--large{
    width: 350px;
    margin: 93px 12.5px;
}
.timebox{
    width: 100vw;
    height: 100vh;
}
.bottomfooter{
    position: fixed;
    width: 100vw;
    bottom: 0;
}
.timebtn{
    display:inline-block;
    text-align: center;
    font-size:16px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    width:65px;
    height:35px;
    line-height: 30px;
    border-radius:17px;
    background:rgba(249,249,249,1);
    border:1px solid rgba(206,206,206,1);
    margin-right: 15px;
}
.timebtncolor{
    color: #fff;
    background:rgba(249,150,0,1);
    border:none;
}
.van-cell__title{
flex:none;
width:100px;
}
.van-cell__value{
    text-align: left;
}
</style>

